import { Col, Container, Row } from "reactstrap";
import { FluentSpinner } from "./fluent-component-wrapper";

const Loader = () => {
    return(
        <Container>
            <Col style={{ marginTop: "40vh" }} sm={{ offset: 5, size: "auto" }}>
                <Row sm={3}>
                    <FluentSpinner />
                </Row>
            </Col>
        </Container>
    )
}

export default Loader;